import { CombinedGraphQLErrors } from '@apollo/client/errors'
import type { GraphQLFormattedError } from 'graphql'

/**
 * The GraphQL errors an Apollo error carries, or an empty array for anything else — a network
 * failure, a plain `Error`, or a non-error value. Accepts `unknown` so call sites never need to
 * guard the error's type first.
 *
 * Narrows on the global brand symbol Apollo stamps onto its errors rather than on prototype
 * identity, so an error that crosses a module or bundle boundary is still read correctly.
 *
 * Five readers build on this one — reach for whichever matches what you already know: a code →
 * `isApolloErrorWithCode`; any code at all → `isIntentionalGraphQLError`; a map of codes you
 * recognize → `getServerErrorValue`; a form's rejected fields → `getServerSideValidationErrors`;
 * any other extension key → `getApolloErrorExtension`.
 * A one-off predicate needs none of them: scan this array directly and narrow what you find.
 */
export const getGraphQLErrors = (error: unknown): readonly GraphQLFormattedError[] =>
  CombinedGraphQLErrors.is(error) ? error.errors : []
